import React from 'react';
import { Link } from 'react-router-dom';

export default ({ image }) => {
  return (
    <div className='Nav-Logo'>
      <Link to='/home'><div style={image}/></Link>
    </div>
  )
}
